import { type ReactNode } from 'react';

import { cn } from '@/lib/cn.js';

interface PageProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Page({ title, description, actions, children, className }: PageProps): JSX.Element {
  return (
    <div className={cn('w-full', className)}>
      <PageHeader title={title} description={description} actions={actions} />
      <div>{children}</div>
    </div>
  );
}

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  className?: string;
}

export function PageHeader({ title, description, actions, breadcrumb, className }: PageHeaderProps): JSX.Element {
  return (
    <div className={cn('mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between', className)}>
      <div className="min-w-0 space-y-1">
        {breadcrumb && (
          <div className="mb-1 flex items-center gap-1.5 whitespace-nowrap text-[13px] text-muted-foreground">
            {breadcrumb}
          </div>
        )}
        <h1 className="text-[26px] font-bold leading-tight tracking-tight">{title}</h1>
        {description && <p className="text-[15px] text-muted-foreground">{description}</p>}
      </div>
      {actions && (
        <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>
      )}
    </div>
  );
}
